"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationStatusBadge = InvitationStatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_1 = require("../../table");
var invitations_data_1 = require("./invitations.data");
function InvitationStatusBadge(props) {
    var status = props.status;
    var STATUS_COLORS = {
        SENT: "navy",
        ACCEPTED: "green",
        CANCELLED: "gray",
    };
    return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: STATUS_COLORS[status], children: invitations_data_1.INVITATION_STATUS_LABELS[status] });
}
